import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import {Button} from "@mui/material";
import {blue, grey} from "@mui/material/colors";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function RefetchButton({refetch, light = false, disabled = false}: {
    refetch: any,
    light?: boolean,
    disabled?: boolean
}) {
    const {uiVisual} = useAppContext();

    const sx = {
        classic: {
            height: 35.69,
            minWidth: 50,
            bgcolor: 'white',
            border: '1px solid #bdbdbd',
            borderRadius: 0,
            ".MuiButton-startIcon": {
                mr: 0
            },
            "&:hover": {
                bgcolor: 'white'
            },
            opacity: disabled ? 0.5 : 1
        },
        modern: {
            height: 35.69,
            minWidth: 50,
            bgcolor: light ? 'white' : '#ECF4FF',
            borderRadius: 1,
            ".MuiButton-startIcon": {
                mr: 0
            },
            "&:hover": {
                bgcolor: 'white'
            },
            opacity: disabled ? 0.5 : 1
        }
    }

    return (
        <Button
            disabled={disabled}
            size="small"
            onClick={() => refetch()}
            variant="text"
            startIcon={<ReplayOutlinedIcon sx={{color: uiVisual === 'classic' ? grey[900] : blue[900]}}/>}
            sx={sx[uiVisual]}
        />
    )
}